import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";
import rehypeSanitize, { defaultSchema } from "rehype-sanitize";

// Release notes may wrap a long passage - a table of removed evaluators and the
// like - in <details>/<summary> so it renders collapsed, and underline the
// summary so the toggle is easy to spot. react-markdown drops raw HTML by
// default, so rehype-raw parses it and rehype-sanitize then allows only the
// tags listed here on top of the safe defaults.
const sanitizeSchema = {
    ...defaultSchema,
    tagNames: [...(defaultSchema.tagNames ?? []), "details", "summary", "u"],
};

export function normalizeMarkdown(text: string): string {
    if (!text) return "";

    return text
        // convert escaped newlines from JSON
        .replace(/\\n/g, "\n")
        // collapse 3+ newlines into max 2
        .replace(/\n{3,}/g, "\n\n")
        .trim();
}

export function Markdown({ children }: { children: string }) {

    return (
        <ReactMarkdown
            remarkPlugins={[remarkGfm]}
            rehypePlugins={[rehypeRaw, [rehypeSanitize, sanitizeSchema]]}
        >
            {children}
        </ReactMarkdown>
    );
}
